// KPI Cards — 6 métricas operativas principales, sin score crudo.
import React from 'react';
import {
  AlertTriangle, Bell, FolderOpen, Clock, Timer, Focus,
} from 'lucide-react';

const CARDS = [
  { key: 'casos_alta_atencion',      label: 'Casos de Alta Atención',   Icon: AlertTriangle, tone: '#B91C1C', bg: '#FADBD8' },
  { key: 'eventos_centinela_activos',label: 'Eventos Centinela Activos',Icon: Bell,          tone: '#8A1616', bg: '#FADBD8' },
  { key: 'casos_abiertos',           label: 'Casos Abiertos',           Icon: FolderOpen,    tone: '#5346E6', bg: '#EEF0FE' },
  { key: 'casos_pendientes',         label: 'Sin Primera Acción',       Icon: Timer,         tone: '#8A4200', bg: '#FFE4CC' },
  { key: 'casos_vencidos',           label: 'Seguimientos Vencidos',    Icon: Clock,         tone: '#8A4200', bg: '#FFE4CC' },
  { key: 'casos_cerrados',           label: 'Casos Cerrados',           Icon: Focus,         tone: '#0F6C4B', bg: '#DFF6EC' },
];

export default function KpiCards({ data, loading }) {
  return (
    <section aria-label="Indicadores operativos" data-testid="kpi-cards">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {CARDS.map(({ key, label, Icon, tone, bg }) => {
          const value = loading ? '…' : (data?.[key] ?? 0);
          return (
            <div
              key={key}
              className="bg-white rounded-2xl p-4 border border-[#E5EAF5] hover:shadow-sm transition"
              data-testid={`kpi-${key}`}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="p-1.5 rounded-lg" style={{ background: bg }}>
                  <Icon className="w-4 h-4" style={{ color: tone }} />
                </div>
              </div>
              <div className="text-2xl lg:text-3xl font-extrabold text-[#0B1B5E]" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                {value}
              </div>
              <div className="text-xs text-[#475472] mt-1 leading-tight">{label}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
